
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["center-point",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"heading","d":"M435 262.7C435.7 129.8 255.4-3.5 256 .1c-.2-1.8-179.1 128.4-179 262.6-3.9 100.2 77.8 185.7 179 185.3 101.1.2 182.7-84.3 179-185.3zM256 369.6c-55.7 0-100.8-45.1-100.8-100.8S200.3 168 256 168s100.8 45.1 100.8 100.8S311.7 369.6 256 369.6z","fill":"currentColor"}}),_c('g',{attrs:{"id":"no-heading"}},[_c('path',{attrs:{"d":"M77.1 185.3c-.7 132.8 179.5 266 178.9 262.5.2 1.7 179-128.4 178.9-262.5C438.8 85.1 357.2-.3 256 .1 155-.1 73.4 84.4 77.1 185.3zM256 112c37.1 0 67.2 30.1 67.2 67.2s-30.1 67.2-67.2 67.2-67.2-30.1-67.2-67.2S218.9 112 256 112z","fill":"currentColor"}})])])
          )
        }
      }
    